import { z } from 'zod';
import { enumParser, PartnerOrganizationActionReason, PartnerOrganizationBillingModelFamily, PartnerOrganizationType, } from '#validation';
const PartnerOrganizationActionSchema = z.object({
    allowed: z.boolean(),
    reasons: z.array(enumParser(PartnerOrganizationActionReason)),
});
const VarResellerActionsSchema = z.object({
    family: z.literal(PartnerOrganizationBillingModelFamily.VAR),
    type: z.literal(PartnerOrganizationType.RESELLER),
    canDelete: PartnerOrganizationActionSchema,
    canEditDemo: PartnerOrganizationActionSchema,
});
const VarClientActionsSchema = z.object({
    family: z.literal(PartnerOrganizationBillingModelFamily.VAR),
    type: z.literal(PartnerOrganizationType.REGULAR),
    canDelete: PartnerOrganizationActionSchema,
    canStartTrial: PartnerOrganizationActionSchema,
    canExtendTrial: PartnerOrganizationActionSchema,
    canStartContract: PartnerOrganizationActionSchema,
    canPreviewContract: PartnerOrganizationActionSchema,
    canUpdateContract: PartnerOrganizationActionSchema,
    canUpsell: PartnerOrganizationActionSchema,
    canSetupUpgrade: PartnerOrganizationActionSchema,
    canViewUpgradeSetup: PartnerOrganizationActionSchema,
    canMigrateContract: PartnerOrganizationActionSchema,
    canTransferWorkspaces: PartnerOrganizationActionSchema,
});
const MspResellerActionsSchema = z.object({
    family: z.literal(PartnerOrganizationBillingModelFamily.MSP),
    type: z.literal(PartnerOrganizationType.RESELLER),
    canDelete: PartnerOrganizationActionSchema,
    canStartTrial: PartnerOrganizationActionSchema,
    canExtendTrial: PartnerOrganizationActionSchema,
    canStartContract: PartnerOrganizationActionSchema,
    canPreviewContract: PartnerOrganizationActionSchema,
    canUpdateContract: PartnerOrganizationActionSchema,
    canUpsell: PartnerOrganizationActionSchema,
    canSetupUpgrade: PartnerOrganizationActionSchema,
    canViewUpgradeSetup: PartnerOrganizationActionSchema,
    canMigrateContract: PartnerOrganizationActionSchema,
    canTransferWorkspaces: PartnerOrganizationActionSchema,
    canEditDemo: PartnerOrganizationActionSchema,
});
const MspClientActionsSchema = z.object({
    family: z.literal(PartnerOrganizationBillingModelFamily.MSP),
    type: z.literal(PartnerOrganizationType.REGULAR),
    canDelete: PartnerOrganizationActionSchema,
    canSetupUpgrade: PartnerOrganizationActionSchema,
    canUpdateUpgradeSetup: PartnerOrganizationActionSchema,
    canViewUpgradeSetup: PartnerOrganizationActionSchema,
    canTransferWorkspaces: PartnerOrganizationActionSchema,
});
export const PartnerOrganizationActionsResponseSchema = z.discriminatedUnion('family', [
    z.discriminatedUnion('type', [
        VarResellerActionsSchema,
        VarClientActionsSchema,
    ]),
    z.discriminatedUnion('type', [
        MspResellerActionsSchema,
        MspClientActionsSchema,
    ]),
]);
